import { Popover, styled as muiStyled } from '@mui/material'
import { DateTimeField, TimeField } from '@mui/x-date-pickers'

function timerTimeStyles({ theme, isTimeInvalid }) {
  return `
  max-width: 430px;
  width: 100%;
    .MuiFormLabel-root {
      display: none;
    }
    .MuiOutlinedInput-notchedOutline{
      display:none;
    }
    .MuiInputBase-input {
        background: #535353;
        border-radius: 7px;
      color: ${isTimeInvalid ? '#ff6666' : '#fff'};
      width: 100%;
      text-align:center;
      font-family: "Roboto Mono", monospace;
    }
  `
}

export const MuiAddPracticeTimerTimeClockInput = muiStyled(TimeField)(timerTimeStyles)
export const MuiAddPracticeTimerDateTimeInput = muiStyled(DateTimeField)(timerTimeStyles)

export const MuiAddIntervalTimePopover = muiStyled(Popover)(
  ({ theme }) => `
  .MuiPaper-root {
    padding: 10px;
    background: #222;
    max-width: 250px !important;
    width: 100% !important;
  }
`,
)

export const CreateNewPracticeStyledInput = muiStyled('input')(
  ({ theme, invalid }) => `
outline: none;
background: transparent;
width: 100%;
color: ${invalid ? '#ff6666' : '#fff'};
::placeholder {
  color: ${invalid ? '#ff6666' : 'unset'};
}
`,
)
